/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */
/* eslint no-param-reassign: "error" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { blockUI, displayMessage, unblockUI } from '../../core_web/store/Application.store';
import ClientFactory from '../api/ApiFactory';
import { ContratosAbertosResponseListResult } from '../api/lar.logistica.api';
import { AppDispatch, AppThunk } from './index';

const ContratosCarregamento = createSlice({
  name: 'ContratosCarregamento',
  initialState: {
    listaContratosCarregamento: {} as ContratosAbertosResponseListResult,
    listaContratosCarregamentoPage: 0,
    listaContratosCarregamentoFilterAndSorting: {} as {
      filter: any;
      sorting: any;
    }
  },
  reducers: {
    setContratosCarregamento(state, action: PayloadAction<ContratosAbertosResponseListResult>) {
      state.listaContratosCarregamento = action.payload;
    },
    setContratosCarregamentoPage(state, action: PayloadAction<number>) {
      state.listaContratosCarregamentoPage = action.payload;
    },
    setListaContratosCarregamentoFilterAndSorting(
      state,
      action: PayloadAction<{ filter: any; sorting: any }>
    ) {
      state.listaContratosCarregamentoFilterAndSorting = action.payload;
    },
    resetData(state) {
      state.listaContratosCarregamento = {} as ContratosAbertosResponseListResult;
      state.listaContratosCarregamentoPage = 0;
      state.listaContratosCarregamentoFilterAndSorting = {} as {
        filter: any;
        sorting: any;
      };
    }
  }
});

export const {
  setContratosCarregamento,
  setContratosCarregamentoPage,
  setListaContratosCarregamentoFilterAndSorting,
  resetData
} = ContratosCarregamento.actions;
export default ContratosCarregamento.reducer;

export function obterContratosCarregamento(matricula: number, tipoFrete: string): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1ContratosCarregamento(matricula, tipoFrete)
      .then((result) => {
        dispatch(setContratosCarregamento(result.toJSON()));
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel obter os contratos: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function updateContratosCarregamentoPage(page: number): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(setContratosCarregamentoPage(page));
  };
}

export function updateContratosCarregamentoFilterAndSorting(filter: any, sorting: any): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(
      setListaContratosCarregamentoFilterAndSorting({
        filter: filter,
        sorting: sorting
      })
    );
  };
}

export function clearData(): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(resetData());
  };
}
